import React, { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { physicianCanPrescribe } from '../doctorPaths';
import { useDoctorWorkspace } from '../doctorWorkspaceContext';
import MedicalPrescriptionList from '../MedicalPrescriptionList';
import { PhysicianPageHeader } from '../ui';
import { DOCTOR_COPY } from '../doctorCopy';

/** Réservé aux médecins (pas aux dentistes). */
export default function DoctorPrescriptionsPage() {
  const { user } = useAuth();
  const { portalPaths, workSiteId, workSites, bumpDashboardStats } = useDoctorWorkspace();

  const workSiteName = useMemo(
    () => workSites.find((s) => String(s.id) === String(workSiteId))?.name || '',
    [workSites, workSiteId]
  );

  if (!user || !physicianCanPrescribe(user.role)) {
    return <Navigate to={portalPaths.DASHBOARD} replace />;
  }

  return (
    <div className="doctor-dashboard recv-dash-pro--main hd-consult-page">
      <PhysicianPageHeader
        badge={DOCTOR_COPY.PHYSICIAN_DASHBOARD.BADGE_PHYSICIAN}
        title="Ordonnances"
        description="Rédaction identique à la fiche clinique — modifiable tant que la pharmacie n’a pas délivré."
      />
      <MedicalPrescriptionList
        showHeader={false}
        workSiteId={workSiteId}
        workSiteName={workSiteName}
        onMutated={bumpDashboardStats}
      />
    </div>
  );
}
